/* liquid_UYfhr3 */

  (function () {
    var restantes = Math.floor(Math.random() * 8) + 2;
    var texto = "Warehouse Sale — Only " + restantes + " left in stock!";
    document.getElementById('stock-badge-text').textContent = texto;
  })();

/* liquid_EreaRL */

  function initGridSizeGuide() {
    var openBtn = document.getElementById('gtes-open');
    var overlay = document.getElementById('gtes-overlay');
    if (!openBtn || !overlay) return;
    if (overlay.dataset.gtesReady === '1') return;
    overlay.dataset.gtesReady = '1';

    var card = document.getElementById('gtes-card');
    var closeBtn = document.getElementById('gtes-close');
    var lastFocus = null;
    var scrollY = 0;

    /* Saca el overlay del contenedor de la sección para que ningún
       overflow/transform del tema lo recorte. */
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

    /* Congela el scroll de la página detrás del modal. Con `locked` a false
       restaura los estilos y devuelve la página a su posición anterior. */
    function lockPageScroll(locked) {
      var style = document.body.style;
      style.position = locked ? 'fixed' : '';
      style.top = locked ? -scrollY + 'px' : '';
      style.width = locked ? '100%' : '';
      style.overflow = locked ? 'hidden' : '';
      if (!locked) window.scrollTo(0, scrollY);
    }

    function open() {
      lastFocus = document.activeElement;
      scrollY = window.pageYOffset || document.documentElement.scrollTop;
      overlay.hidden = false;
      overlay.classList.add('is-open');
      lockPageScroll(true);
      if (card) card.focus();
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
      lockPageScroll(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    /* Horma normal / ancha */
    var tabs = [
      { btn: document.getElementById('gtes-tab-normal'), panel: document.getElementById('gtes-panel-normal') },
      { btn: document.getElementById('gtes-tab-ancha'), panel: document.getElementById('gtes-panel-ancha') }
    ];

    tabs.forEach(function (item) {
      if (!item.btn || !item.panel) return;
      item.btn.addEventListener('click', function () {
        tabs.forEach(function (other) {
          var active = other === item;
          other.btn.setAttribute('aria-selected', active ? 'true' : 'false');
          other.panel.hidden = !active;
        });
      });
    });

    /* Acordeón de medición */
    var measureBox = document.getElementById('gtes-measure');
    var measureBtn = document.getElementById('gtes-measure-btn');
    if (measureBox && measureBtn) {
      measureBtn.addEventListener('click', function () {
        var isOpen = measureBox.classList.toggle('is-open');
        measureBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
    return { open: open };
  }
  var guideButton = document.getElementById('gtes-open');
  if (guideButton) guideButton.addEventListener('click', function prepareGuide() {
    var template = document.getElementById('grid-size-guide-template');
    if (template) template.replaceWith(template.content.cloneNode(true));
    var guide = initGridSizeGuide();
    if (guide) guide.open();
  }, { once: true });

/* liquid_byPnjY */

  (function () {
    // Dias corridos a somar a partir de hoje (1 = amanhã / dia seguinte).
    var SHIP_DAYS = 1;
    // Locale da data exibida (en-GB => "Fri, 4 Jul").
    var DATE_LOCALE = 'en-US';

    var el = document.getElementById('ccc-ship-date');
    if (el) {
      var shipDate = new Date();
      shipDate.setDate(shipDate.getDate() + SHIP_DAYS);
      el.textContent = shipDate.toLocaleDateString(DATE_LOCALE, {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      });
    }
  })();

/* header-promotion */

  (function () {
    /* Contagem regressiva até a próxima meia-noite (hora local do visitante),
       ao zerar, reinicia para a meia-noite seguinte. */
    var bars = document.querySelectorAll('.ctdb-bar:not([data-ctdb-ready])');
    if (!bars.length) return;

    function nextMidnight() {
      var d = new Date();
      d.setHours(24, 0, 0, 0);
      return d.getTime();
    }

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    for (var i = 0; i < bars.length; i++) {
      (function (bar) {
        bar.setAttribute('data-ctdb-ready', '');

        var hEl = bar.querySelector('[data-ctdb-hours]');
        var mEl = bar.querySelector('[data-ctdb-minutes]');
        var sEl = bar.querySelector('[data-ctdb-seconds]');
        if (!hEl || !mEl || !sEl) return;

        var deadline = nextMidnight();

        function tick() {
          var total = deadline - Date.now();

          if (total <= 0) {
            deadline = nextMidnight();
            total = deadline - Date.now();
          }

          hEl.textContent = pad(Math.floor(total / 3600000) % 24);
          mEl.textContent = pad(Math.floor(total / 60000) % 60);
          sEl.textContent = pad(Math.floor(total / 1000) % 60);
        }

        tick();
        var timer;
        function syncTimer() {
          clearInterval(timer);
          if (!document.hidden) { tick(); timer = setInterval(tick, 1000); }
        }
        document.addEventListener('visibilitychange', syncTimer);
        syncTimer();
      })(bars[i]);
    }
  })();
